import { store } from "../store";

export const updateThemeMode = (themeMode) => {
  // Sauvegarder dans localStorage
  localStorage.setItem("theme", themeMode);

  // Appliquer l'attribut data-theme au document pour les CSS variables
  document.documentElement.setAttribute("data-theme", themeMode);

  // Mettre à jour le state Redux
  return store.dispatch({ type: "themeMode/update", payload: themeMode });
};
